import { APIContact, ContactGroup } from '@super-software-inc/foundation'

/**
 * Determines if a contact can view (and send) internal comments on a task.
 * @param contact The user's contact object
 * @param associationIds Array of association/property IDs relevant to the task
 * @param taskAssociationId The association/property ID for the task (or null for no property)
 * @returns boolean
 */
const includeInternalComments = (
  contact: APIContact,
  associationIds: string[],
  taskAssociationId: string | null,
): boolean => {
  // --- CASE 1: Task has a property ---
  // User must be staff/management in that property
  if (taskAssociationId) {
    return (
      contact.propertyInfo?.some(
        p =>
          associationIds.includes(p.associationId) &&
          p.groups.some(
            g => g === ContactGroup.Staff || g === ContactGroup.Management,
          ),
      ) ?? false
    )
  }

  // --- CASE 2: Task has NO property ---
  // User must be staff/management in ANY property
  return (
    contact.propertyInfo?.some(p =>
      p.groups.some(
        g => g === ContactGroup.Staff || g === ContactGroup.Management,
      ),
    ) ?? false
  )
}

export default includeInternalComments
